import { render, staticRenderFns } from "./data-export.vue?vue&type=template&id=1ae0bf30&scoped=true"
import script from "./data-export.vue?vue&type=script&lang=js"
export * from "./data-export.vue?vue&type=script&lang=js"
import style0 from "./data-export.vue?vue&type=style&index=0&id=1ae0bf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae0bf30",
  null
  
)

export default component.exports